import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=ddde122e&scoped=true"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"
import style0 from "./picture.vue?vue&type=style&index=0&id=ddde122e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde122e",
  null
  
)

export default component.exports